import { useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingExpertDataService from "../../services/OnboardingExpert";
import { SingleOnboardingRow } from "../../components/List/SingleOnboardingRow";
import { CreateOnboardingExpert } from "../../components/Modals/CreateOnboardingExpert";
export const OnboardingExpertList = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState<any>();
  const [modal, setModal] = useState<any>("");
  const isExpertdelete = (isdelete: true) => {
    fetchData();
  };
  const fetchData = async () => {
    setIsLoading(true);
    OnboardingExpertDataService.getOnboardingExperts()
      .then((res: any) => {
        setList(res.data);
        setIsLoading(false);
      })
      .catch((error: any) => {
        setIsLoading(false);
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - App Experts Onboarding</div>
      <div className=" p-4">
        {/* top section */}
        <div className="top_section_container">
          <div className="expert_container_item expert_list_button ">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("createExpert");
                  onOpen();
                }}
              >
                Add Expert For Onboarding
              </button>
            </div>

            {modal === "createExpert" && (
              <CreateOnboardingExpert
                isOpen={isOpen}
                onClose={onClose}
                // input={pageSize}
                func={isExpertdelete}
              />
            )}
          </div>
        </div>

        {/* Main secttion */}
        <div className="main-section">
          <table className="table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Form Status</th>
                <th>Status</th>
                <th>Approval</th>
                <th>Create Expert</th>
                <th>View</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleOnboardingRow
                    key={el._id}
                    data={el}
                    id={el._id}
                    func={isExpertdelete}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
